import { render, staticRenderFns } from "./CallTableIssuesActions.vue?vue&type=template&id=4f649053"
import script from "./CallTableIssuesActions.vue?vue&type=script&lang=js"
export * from "./CallTableIssuesActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports